import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Analytics } from "@/lib/analyticsShim";

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogPortal = DialogPrimitive.Portal;
export const DialogClose = DialogPrimitive.Close;

export const DialogOverlay = React.forwardRef(function DialogOverlay({ className = "", ...props }, ref) {
  return (
    <DialogPrimitive.Overlay
      ref={ref}
      className={`fixed inset-0 z-50 bg-black/50 ${className}`.trim()}
      {...props}
    />
  );
});

export const DialogContent = React.forwardRef(function DialogContent({ className = "", children, variant = "modal", ...props }, ref) {
  const contentClass = variant === "drawer"
    ? "fixed right-0 top-0 z-50 h-screen w-full max-w-md bg-white shadow-xl"
    : "fixed left-1/2 top-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-xl";

  return (
    <DialogPortal>
      <DialogOverlay />
      <DialogPrimitive.Content
        ref={ref}
        className={`${contentClass} ${className}`.trim()}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPortal>
  );
});

export const DialogHeader = ({ className = "", ...props }) => (
  <div className={`flex flex-col space-y-1.5 ${className}`.trim()} {...props} />
);

export const DialogTitle = React.forwardRef(function DialogTitle({ className = "", ...props }, ref) {
  return <DialogPrimitive.Title ref={ref} className={`text-lg font-semibold ${className}`.trim()} {...props} />;
});

export const DialogDescription = React.forwardRef(function DialogDescription({ className = "", ...props }, ref) {
  return <DialogPrimitive.Description ref={ref} className={`text-sm text-gray-500 ${className}`.trim()} {...props} />;
});
